import axios from "axios";
import Config from "src/config";

const BASE_URL = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chamados-config`;

// Status
export const actionListaStatusChamados = (querys) => {
    return axios({ method: "get", url: `${BASE_URL}/status${querys}` });
};

export const actionCriarStatusChamado = (data) => {
    return axios({ method: "post", url: `${BASE_URL}/status/criar`, data });
};

export const actionEditarStatusChamado = (statusId, data) => {
    return axios({ method: "put", url: `${BASE_URL}/status/${statusId}/editar`, data });
};

export const actionReordenarStatusChamados = (data) => {
    return axios({ method: "put", url: `${BASE_URL}/status/reordenar`, data });
};

export const actionDeletarStatusChamado = (statusId) => {
    return axios({ method: "delete", url: `${BASE_URL}/status/${statusId}/deletar` });
};

// Caixas de Entrada
export const actionListaCaixasEntrada = (querys) => {
    return axios({ method: "get", url: `${BASE_URL}/caixas-entrada${querys}` });
};

export const actionCriarCaixaEntrada = (data) => {
    return axios({ method: "post", url: `${BASE_URL}/caixas-entrada/criar`, data });
};

export const actionEditarCaixaEntrada = (caixaId, data) => {
    return axios({ method: "put", url: `${BASE_URL}/caixas-entrada/${caixaId}/editar`, data });
};

export const actionDeletarCaixaEntrada = (caixaId) => {
    return axios({ method: "delete", url: `${BASE_URL}/caixas-entrada/${caixaId}/deletar` });
};

export const actionBuscarCaixaEntrada = (caixaId) => {
    return axios({ method: "get", url: `${BASE_URL}/caixas-entrada/${caixaId}` });
};

export const actionSalvarCamposCaixa = (caixaId, data) => {
    return axios({ method: "put", url: `${BASE_URL}/caixas-entrada/${caixaId}/campos`, data });
};

export const actionTogglePublicarCaixa = (caixaId, data) => {
    return axios({ method: "put", url: `${BASE_URL}/caixas-entrada/${caixaId}/publicar`, data });
};

// Prioridades
export const actionListaPrioridades = (querys) => {
    return axios({ method: "get", url: `${BASE_URL}/prioridades${querys}` });
};

export const actionCriarPrioridade = (data) => {
    return axios({ method: "post", url: `${BASE_URL}/prioridades/criar`, data });
};

export const actionEditarPrioridade = (prioridadeId, data) => {
    return axios({ method: "put", url: `${BASE_URL}/prioridades/${prioridadeId}/editar`, data });
};

export const actionReordenarPrioridades = (data) => {
    return axios({ method: "put", url: `${BASE_URL}/prioridades/reordenar`, data });
};

export const actionDeletarPrioridade = (prioridadeId) => {
    return axios({ method: "delete", url: `${BASE_URL}/prioridades/${prioridadeId}/deletar` });
};
